<template>
  <div class="select-time">
    <el-cascader
    v-model="selectedTime"
    :options="options"
    :placeholder="placeholder"
    :class="{'y-w-300': fromPage == 'importPage', 'y-w-530': fromPage == 'createOrder'}"
    @change="handleChange"
    @focus="reSetTimeOptions">
    <template slot-scope="{ node, data }">
      <div v-if="data.label == 'empty'" style="color: #999;height: 50px;line-height: 50px;margin-top: 40%;">
        今日取件时间已运营结束，可以继续预约明天上门取件
      </div>
      <div v-else>{{ data.label }}</div>
    </template>
  </el-cascader>
  </div>
</template>
<script>
import { getTimeSegmentsForRetrunPickupApi, getImportTimeSegmentsApi } from '@/api/waybillPrint/returnPickupPrint'
export default {
  name: "select-time",
  props: {
    curTime: {
      type: Array,
      default: function() {
        return [];
      }
    },
    typeFlag: {
      type: String,
      default: '1'
    },
    receiveAddressInfo: {
      type: String,
      default: ''
    },
    fromPage: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data() {
    return {
      selectedTime: [],
      options: []
    };
  },
  created() {
    this.generateTimeOptions()
  },
  methods: {
    generateTimeOptions() {
      let params = {};
      let apiUrlFn = getTimeSegmentsForRetrunPickupApi;
      if (this.fromPage == 'importPage') {
        apiUrlFn = getImportTimeSegmentsApi;
      } else {
        if (!this.receiveAddressInfo) {
          return false;
        }
        let addressInfo = this.receiveAddressInfo.split('|')
        console.log('addressInfo==', addressInfo)
        if (!addressInfo[0] || !addressInfo[1] || !addressInfo[2]) {
          return false;
        }
        params = {
          "cityName": addressInfo[2],
          "districtName": addressInfo[1],
          "provinceName": addressInfo[0],
          "userId": "f69314be714d4aa4b9281ddecc7aff2d"
        }
      }
      apiUrlFn(params).then(res => {
        if (res.success && res.data) {
          let optionList = res.data || [];
          this.options = [];
          optionList.forEach((m,idx) => {
            let children = [];
            m.segments.forEach(o => { 
              if (this.typeFlag == '1') {
                // 当日取
                if(o.timeSeg == '当日取' && o.effective) {
                  let obj = {...o, value: `${o.startTime}-${o.endTime}`, label: o.timeSeg, disabled: m.dayFlag == '0' ? !o.effective : false};
                  children.push(obj);
                }
                console.log('children', children)
              } else {
                if(o.timeSeg != '当日取' && o.effective) {
                  let obj = {...o, value: `${o.startTime}-${o.endTime}`, label: o.timeSeg, disabled: m.dayFlag == '0' ? !o.effective : false};
                  children.push(obj);
                }
              }
            })
            if (!children.length) {
              children.push({label: 'empty', disabled: true, isLeaf: true})
            }
            let obj = {
              value: m.dayFlag == '0' ? 'today' : 'nextDay',
              label: m.dayFlag == '0' ? '今天' : '明天',
              leaf: true,
              effective: m.effective,
              children: children
            };
            this.options.push(obj); 
          })
          // this.options = [...this.options];
        }
      })
    },
    reSetTimeOptions() {
      if (this.fromPage == 'createOrder') {
        this.$emit('setTimeType', this.typeFlag); //将父级时间类型设置为定时取件时间
      }
      this.generateTimeOptions()
    },
    handleChange(value) {
      console.log('Selected time:', value)
      // 这里可以添加选择后的处理逻辑
      this.$emit('selectedTime', value)
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.y-w-530 {
  width: 210px;
}
</style>